import { LoadingButton } from "@mui/lab";

export function SocialButton({ icon, children, ...rest }) {
  return (
    <LoadingButton
      size="small"
      fullWidth
      variant="contained"
      startIcon={icon}
      color="google"
      sx={{
        border: "1px solid #747775",
        py: 1,
        px: 2,
        "&.Mui-disabled": {
          border: "1px solid transparent"
        }
      }}
      {...rest}
    >
      {children}
    </LoadingButton>
  );
}
